// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatSourceRevokedNotice-modulenotice__ZSIMJ GretaAIChatLimitNotice-modulenotice__U4wMw";
export { _1 as "notice" }
